import { render, staticRenderFns } from "./SendQuote.vue?vue&type=template&id=13f20135&scoped=true&"
import script from "./SendQuote.vue?vue&type=script&lang=js&"
export * from "./SendQuote.vue?vue&type=script&lang=js&"
import style0 from "./SendQuote.vue?vue&type=style&index=0&id=13f20135&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f20135",
  null
  
)

export default component.exports